/* @flow */

export const PLATFORM = {
    DESKTOP: ('desktop' : 'desktop'),
    MOBILE:  ('mobile' : 'mobile')
};
